import { render, staticRenderFns } from "./InstallAndManageView.vue?vue&type=template&id=904f130c&"
import script from "./InstallAndManageView.vue?vue&type=script&lang=js&"
export * from "./InstallAndManageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('904f130c')) {
      api.createRecord('904f130c', component.options)
    } else {
      api.reload('904f130c', component.options)
    }
    module.hot.accept("./InstallAndManageView.vue?vue&type=template&id=904f130c&", function () {
      api.rerender('904f130c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/services/hosting/shared/wordpress/InstallAndManageView.vue"
export default component.exports